import React from 'react';
import { Loader } from 'lucide-react';

const LoadingOverlay = ({ loading, apiLoading }) => (
  (loading || apiLoading) && (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg flex items-center gap-3">
        <Loader className="animate-spin text-blue-600" size={24} />
        <span className="text-gray-700">Processing...</span>
      </div>
    </div>
  )
);

export default LoadingOverlay;